if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.tooltipCallback();
        this.toggleVolumePricing();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max;
        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const notifyMeButton = document.querySelector('.btn.klaviyo-bis-trigger')
          if (notifyMeButton) {
              notifyMeButton.classList.remove('hidden');
          }

        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
          for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }}
          else if (selector === '.quantity__label') {
            current.outerHTML = updated.outerHTML;
          }
          else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      tooltipCallback() {
        this.tooltipTrigger = this.querySelector('.product-call-pricing__tooltip');
        this.tooltipText = this.querySelector('.product-call-pricing__tooltip-text');

        if (this.tooltipTrigger && this.tooltipText) {
          this.tooltipTrigger.addEventListener('click', this.toggleTooltip);
          this.tooltipTrigger.addEventListener('keydown', this.handleKeyPress);
        }
      }

      toggleVolumePricing() {
        this.volumePricingButton = this.querySelector('.volume-pricing_title');
        this.volumePricinList = this.querySelector('.volume-pricing_list');
        this.volumePricingButtonToggle = this.querySelector('.volume-pricing_toggle');

        if (this.volumePricingButton) {
          const togglePricingList = () => {
            this.volumePricinList.classList.toggle('active');
            const isActive = this.volumePricinList.classList.contains('active');
            this.volumePricingButtonToggle.textContent = isActive ? '-' : '+';
            this.volumePricingButton.setAttribute('aria-expanded', isActive);
          };

          this.volumePricingButton.addEventListener('click', togglePricingList);

          this.volumePricingButton.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              togglePricingList();
            }
          });
        }
      }

      toggleTooltip() {
        const isTooltipVisible = this.tooltipText.style.display === 'block';
        this.tooltipText.style.display = isTooltipVisible ? 'none' : 'block';
      }

      handleKeyPress(event) {
        switch (event.key) {
          case 'Escape':
          case 'Tab':
            this.tooltipText.style.display = 'none';
            break;
          case 'Enter':
          case ' ':
            this.toggleTooltip();
            event.preventDefault();
            break;
          default:
            break;
        }
      }
    }
  );
  const setWishlistButtonFocusable = (el) => {
    if (el && (!el.hasAttribute('tabindex') || el.getAttribute('tabindex') !== '0')) el.setAttribute('tabindex', '0');
    if (el) el.setAttribute('role', 'button');
  };

  const focusableSelectors = ['.th_wl_button', '.th_wl_button_after'];

  const obs = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(n => {
        if (n.nodeType === 1) {
          focusableSelectors.forEach(selector => {
            if (n.classList.contains(selector.replace('.', ''))) setWishlistButtonFocusable(n);
            n.querySelectorAll(selector).forEach(setWishlistButtonFocusable);
          });
        }
      });
    });
  });
  obs.observe(document.body, { childList: true, subtree: true });
  focusableSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(setWishlistButtonFocusable);
  });

  document.body.addEventListener('keydown', e => {
    if ((e.key === 'Enter' || e.key === ' ') && (e.target.classList.contains('th_wl_button') || e.target.classList.contains('th_wl_button_after'))) {
      e.preventDefault();
      e.target.click();
      e.target.focus();
    }
  });
}

const wishlistObserver = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        if (node.id === 'th-wl-sucess-mgs') {
          node.setAttribute('aria-live', 'assertive');
          node.setAttribute('role', 'alert');
          node.setAttribute('tabindex', '-1');
          
          const liveRegion = document.getElementById('wishlist-live-region');
          if (liveRegion) {
            liveRegion.textContent = '';
            setTimeout(() => {
              liveRegion.textContent = node.textContent;
            }, 10);
          }
        }
        
        if (node.classList.contains('th_wl_button')) {
          node.setAttribute('aria-label', 'addtoWishlist');
        }
        if (node.classList.contains('th_wl_button_after')) {
          node.setAttribute('aria-label', 'removefromWishlist');
        }
        
        const wishlistButtons = node.querySelectorAll('.th_wl_button, .th_wl_button_after');
        wishlistButtons.forEach(button => {
          if (button.classList.contains('th_wl_button')) {
            button.setAttribute('aria-label', 'addtoWishlist');
          }
          if (button.classList.contains('th_wl_button_after')) {
            button.setAttribute('aria-label', 'removefromWishlist');
          }
        });
      }
    });
  }
});

wishlistObserver.observe(document.body, { childList: true, subtree: true });